// File hash verification. Confirm the file in front of the verifier
// produces the SHA-256 declared in the receipt's `subject.hash`.
// This is the proof that "the receipt describes THIS thing."
//
// Web Crypto runs in browsers, Cloudflare Workers, and Bun — same API,
// same bytes.

function bytesToHex(bytes: Uint8Array): string {
  let s = "";
  for (const b of bytes) s += b.toString(16).padStart(2, "0");
  return s;
}

export async function sha256Hex(data: Uint8Array): Promise<string> {
  // Cast: TS 5.7's Uint8Array<ArrayBufferLike> isn't assignable to
  // BufferSource without narrowing. The Workers/browser runtime never hands
  // us a SharedArrayBuffer-backed view here, so the cast is safe in practice.
  const digest = await crypto.subtle.digest("SHA-256", data as BufferSource);
  return bytesToHex(new Uint8Array(digest));
}

// Returns true iff sha256(fileBytes) === expectedHashHex (case-insensitive
// on the input but compared lowercase, since canonical receipt form is
// lowercase hex).
export async function verifyFileHash(
  fileBytes: Uint8Array,
  expectedHashHex: string,
): Promise<boolean> {
  const got = await sha256Hex(fileBytes);
  return got === expectedHashHex.toLowerCase();
}
